import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { constants } from "../app.constants";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Button = styled.button`
  background-color: var(--purple);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  color: var(--white);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    transform: scale(1.1);
  }
  &:focus {
    transform: scale(0.9);
  }
  @media only Screen and (max-width: 40em) {
    font-size: 1.2rem;
    &:hover {
      transform: none;
    }
    &:focus {
      transform: none;
    }
  }
`;

const Nav = styled.nav`
  width: 35rem;
  // max-width: rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;
  @media only Screen and (max-width: 48em) {
    display: none;
  }
  a {
    font-weight: 500;
    line-height: 1.5;
    font-size: 1.1rem;
    &::after {
      content: "";
      display: block;
      height: 3px;
      width: 0;
      background: transparent;
      transition: width 0.5s;
    }
    &:not(:last-child):hover::after {
      width: 100%;
      background: var(--purple);
    }
    /* &:not(:last-child) {
      margin-right: 2rem;
    } */
    /* @media only Screen and (max-width: 48em) {
      &:not(:last-child) {
        margin-right: 1rem;
      }
    } */
  }
`;

const Header = () => {
  const navigate = useNavigate();

  gsap.registerPlugin(ScrollTrigger);

  const scrollUp = (id: any, e: any) => {
    e.preventDefault();
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  return (

    <div className="flex flex-col lg:flex-row lg:justify-between items-center lg:px-24 bg-white z-50 shadow-lg fixed w-full top-0">
      <img onClick={() => { navigate('/') }} className="cursor-pointer w-[18rem] h-auto py-5" src={constants.images.EastLawLogo2} alt="EastLaw" />

      <Nav>
        <a className="cursor-pointer" onClick={(e) => {
          navigate('/');
          scrollUp("home", e);
        }}>
          Home
        </a>
        <a className="cursor-pointer" onClick={(e) => {navigate('/');scrollUp("packages", e)}}>
          Packages
        </a>
        <a className="cursor-pointer" onClick={(e) => {navigate('/');scrollUp("about", e)}}>
          About Us
        </a>
        <a className="cursor-pointer"  onClick={(e) => {navigate('/');scrollUp("contact", e)}}>
          Contact Us
        </a>
        <a onClick={()=> {navigate('/auth')}}>
          <Button>Login | Register</Button>
        </a>
      </Nav>
    </div>

  );
};

export default Header;